<template>
    <div
        class="kgr-inputGroup"
        :class="{ 'with-errors': error.forField('file') }"
    >
        <div class="kgr-inputGroup__label ui-droppable">
            {{ $t('Bereichsbild') }}
        </div>

        <div class="kgr-postfix kgr-postfix--gutters kgr-postfix--top kgr-row kgr-row--smallMargin">
            <div
                v-if="!loading"
                class="kgr-postfix__fixed"
            >
                <img
                    :src="imageUrl"
                    :alt="area.name"
                />
            </div>
            <div class="kgr-postfix__fluid">
                <kgr-file-chooser @change="onImageChange" />
                <template v-if="imageFile">
                    <hr class="kgr-separator kgr-separator--light" />
                    <kgr-button
                        :value="$t('Bild hochladen')"
                        :pending="pendingUpload"
                        type="blue"
                        @click="uploadImage"
                    />
                </template>
                <template v-if="!loading && area.hasImage && !imageFile">
                    <hr class="kgr-separator kgr-separator--light" />
                    <kgr-button
                        :value="$t('Bild löschen?')"
                        class="kgr-button kgr-button--small kgr-button--danger"
                        @click="deleteImage()"
                    />
                </template>
            </div>
        </div>

        <div
            v-if="error.forField('file')"
            class="kgr-inputGroup__text kgr-inputGroup__text--error"
        >
            {{ error.messageForField('file') }}
        </div>
        <div class="kgr-inputGroup__text">
            {{ $t('Hier kannst du ein Bild einfügen. Die Datei (z.B. JPG, PNG oder GIF) sollte eine Mindestbreite von 300 Pixel haben und darf eine Dateigröße von 2 MB nicht überschreiten.') }}
        </div>
    </div>
</template>

<script>
import AreaRepository from '../../js/repository/AreaRepository';
import Error from '../../js/model/Error';
import FileChooser from '../../components/common/file/FileChooser';
import KgrButton from '../../components/common/form/button/KgrButton';

export default {
    components: {
        'kgr-file-chooser': FileChooser,
        'kgr-button': KgrButton,
    },
    props: {
        locationId: {
            type: String,
            required: true,
        },
        areaId: {
            type: String,
            required: true,
        },
    },
    data() {
        return {
            imageFile: null,
            error: new Error(),
            pendingUpload: false,
            loading: true,
            cacheBreaker: Date.now(),
            area: null,
        };
    },
    computed: {
        imageUrl() {
            return `${this.area.imageUrl}?v=${this.cacheBreaker}`;
        },
    },
    created() {
        AreaRepository.find(this.locationId, this.areaId)
            .then((area) => {
                this.error = new Error();
                this.area = area;
            })
            .catch((error) => this.handleError(error))
            .finally(() => this.loading = false);
    },
    methods: {
        deleteImage() {
            showConfirm(this.$t('confirm'), this.$t('Soll das Bild wirklich gelöscht werden?'), () => {
                AreaRepository.removeImage(this.locationId, this.areaId)
                    .then(() => {
                        this.error = new Error();
                        this.cacheBreaker = Date.now();
                        this.area.hasImage = false;

                        this.$forceUpdate();
                        this.$notify.success('Bild erfolgreich gelöscht');
                    })
                    .catch((error) => this.handleError(error));

                this.imageFile = null;
            }, 'Ok');
        },
        onImageChange(imageFile) {
            this.imageFile = imageFile;
        },
        uploadImage() {
            if (this.imageFile) {
                this.pendingUpload = true;
                AreaRepository.uploadImage(this.locationId, this.areaId, this.imageFile)
                    .then(() => {
                        this.error = new Error();
                        this.cacheBreaker = Date.now();
                        this.area.hasImage = true;
                        this.imageFile = null;

                        this.$forceUpdate();
                        this.$notify.success('Bild erfolgreich hochgeladen');
                    })
                    .catch((error) => this.handleError(error))
                    .finally(() => this.pendingUpload = false);
            }
        },
        handleError(error) {
            this.error = error;
            this.$notify.error('saveChanges.error');
        },
    },
};
</script>

<style scoped lang="scss" rel="stylesheet/scss">
</style>
